import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import "./App.css";
import GrainOverlay from "./components/atmos/GrainOverlay";
import CustomCursor from "./components/atmos/CustomCursor";
import NavBar from "./components/atmos/NavBar";
import SiteBackground from "./components/atmos/SiteBackground";
import "./lib/embedded";
import SsoGate from "./components/atmos/SsoGate";
import AdminDashboard from "./pages/Admin";
import Dashboard from "./pages/Dashboard";
import Landing from "./pages/Landing";
import Questionnaire from "./pages/Questionnaire";
import Report from "./pages/Report";

const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Landing /></PageTransition>} />
        <Route path="/dashboard" element={<PageTransition><Dashboard /></PageTransition>} />
        <Route path="/admin" element={<PageTransition><AdminDashboard /></PageTransition>} />
        <Route path="/profile/:id" element={<Questionnaire />} />
        <Route path="/assessment/:id" element={<Questionnaire />} />
        <Route path="/report/:id" element={<PageTransition><Report /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App relative isolate">
      <BrowserRouter>
        <SsoGate>
          <ScrollToTop />
          <SiteBackground />
          <CustomCursor />
          <GrainOverlay />
          <NavBar />
          <AnimatedRoutes />
        </SsoGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
